import getApiClient from '@/plugins/api'

export default {
  loadItem() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    self.$store.commit('startLoading')

    api.get(`settings/${itemId}`, {
      params: self.searchParams
    })
      .then((result) => {
        self.setting = result.data
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  save() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    self.success = false
    self.error = false
    self.errors = {}
    self.$store.commit('startLoading')
    api.patch(`settings/${itemId}`, {
      value: self.setting.value.toString()
    }, {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
      .then(response => {
        self.setting = response.data
        self.success = true
      })
      .catch(error => {
        self.error = true
        self.processErrors(error.response.data.violations)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  processErrors(errors) {
    const self = this
    self.errors = {}

    errors.forEach(error => {
      self.errors[error.propertyPath] = error.message
    })
  },

  setValue(event) {
    this.setting.value = event.target.checked ? 1 : 0
  }
}
